import { render, staticRenderFns } from "./print-foot.vue?vue&type=template&id=d993810a&scoped=true"
import script from "./print-foot.vue?vue&type=script&lang=js"
export * from "./print-foot.vue?vue&type=script&lang=js"
import style0 from "./print-foot.vue?vue&type=style&index=0&id=d993810a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d993810a",
  null
  
)

export default component.exports